import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getDropshipSummary, getDropshipTotal } from "../../redux/actions/dropshipSummaryReports.action.js";
import { getAdminLocation } from "../../redux/actions/adminLocation.action.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { CSVLink } from "react-csv";

const DropshipTotal = ({ token }) => {
  TabTitle("DropShip Total")
  const { ecommerceDaily } = useSelector((state) => state);
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  var date = moment();
  const [dateTypeId, setDateTypeId] = useState("lw");
  const [monthId, setMonthId] = useState(date.format("MM"));
  const [yearId, setYearId] = useState(date.format("Y"));
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { gender, dropshipTotal } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");

  const { onDownload: onDownloadReport } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Dropship Total",
    sheet: "Sheet 1",
  });


  useEffect(() => {
    let year = yearId;
    let currentYearStartDate = moment().startOf("year").format("MM/DD/YYYY");
    let currentYearEndDate = moment().endOf("year").format("MM/DD/YYYY");
    if (dateTypeId === "mtd") {
      currentYearStartDate = moment().format("MM") + "/" + "01" + "/" + year;
      currentYearEndDate = moment().format("MM") + "/" + moment().format("DD") + "/" + year;
    } else if (dateTypeId === "lw") {
      currentYearStartDate = moment().subtract(7, 'days').format("MM/DD/YYYY");
      currentYearEndDate = moment().format("MM/DD/YYYY");
    } else if (dateTypeId === "stds") { // January to June only
      currentYearStartDate = moment().startOf('year').format("MM/DD/YYYY");
      currentYearEndDate = moment().month(5).date(30).format("MM/DD/YYYY");
    } else if (dateTypeId === "stdf") {
      currentYearStartDate = moment().startOf('year').add(6, 'months').startOf('month').format("MM/DD/YYYY");
      currentYearEndDate = moment().endOf('year').format("MM/DD/YYYY");
    } else if (dateTypeId === "ytd") {
      currentYearStartDate = moment().startOf('year').format("MM/DD/YYYY");
      currentYearEndDate = moment().endOf('year').format("MM/DD/YYYY");
    }
    const newState = {
      cy_start_date: currentYearStartDate,
      cy_end_date: currentYearEndDate,
    };
    setFormState(newState);
  }, [dateTypeId, monthId, yearId]);


  useEffect(() => {
    dispatch(getGender(token, menuId));
    dispatch(getAdminLocation(token, menuId));
  }, [dispatch, menuId, token]);


  console.log({ formState, dateTypeId })

  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getDropshipTotal(token, values)).then((res) => {
        if (res.type === "GET_DROPSHIP_TOTAL_REPORTS_SUCCESS") {
          setLoading(false);
          downloadExcelFileData(res?.payload?.data);

        }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }
  const [excelData, setExcelData] = useState([]);


  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "SKU": v.sku,
          "Inseam": v.inseam,
          "Style": v.style_name,
          "Wash": v.wash_name,
          "Current Season": v.new_season,
          "Bloomingdales SHP U": v.blooming_shipped,
          "Bloomingdales RTRN U": v.blooming_returned,
          "Bloomingdales NET U": v.blooming_net,
          "Bloomingdales RET %": v.blooming_ret_rate,
          "Moda SHP U": v.moda_shipped,
          "Moda RTRN U": v.moda_returned,
          "Moda NET U": v.moda_net,
          "Moda RET %": v.moda_ret_rate,
          // "Maisonette SHP U": v.maisonet_shipped,
          // "Maisonette RTRN U": v.maisonet_returned,
          // "Maisonette NET U": v.maisonet_net,
          // "Maisonette RET %": v.maisonet_ret_rate,
          "Nord D2C SHP U": v.nord_shipped,
          "Nord D2C RTRN U": v.nord_returned,
          "Nord D2C NET U": v.nord_net,
          "Nord D2C RET %": v.nord_ret_rate,

          "Nord Marketplace SHP U": v.nordmrkt_shipped,
          "Nord Marketplace RTRN U": v.nordmrkt_returned,
          "Nord Marketplace NET U": v.nordmrkt_net,
          "Nord Marketplace RET %": v.nordmrkt_ret_rate,
          // "Neiman D2C SHP U": v.neiman_shipped,
          // "Neiman D2C RTRN U": v.neiman_returned,
          // "Neiman D2C NET U": v.neiman_net,
          // "Neiman D2C RET %": v.neiman_ret_rate,
          "Saks D2C SHP U": v.saksdrp_shipped,
          "Saks D2C RTRN U": v.saksdrp_returned,
          "Saks D2C NET U": v.saksdrp_net,
          "Saks D2C RET %": v.saksdrp_ret_rate,
          // "Saks Marketplace SHP U": v.saksmrkt_shipped,
          // "Saks Marketplace RTRN U": v.saksmrkt_returned,
          // "Saks Marketplace NET U": v.saksmrkt_net,
          // "Saks Marketplace RET %": v.saksmrkt_ret_rate,
          "Anthropologie SHP U": v.outfitters_shipped,
          "Anthropologie RTRN U": v.outfitters_returned,
          "Anthropologie NET U": v.outfitters_net,
          "Anthropologie RET %": v.outfitters_ret_rate,
          // "Army & Air Force SHP U": v.aafes_shipped,
          // "Army & Air Force RTRN U": v.aafes_returned,
          // "Army & Air Force NET U": v.aafes_net,
          // "Army & Air Force RET %": v.aafes_ret_rate,
          // "Rent the Runway Marketplace SHP U": v.rtrmrkt_shipped,
          // "Rent the Runway Marketplace RTRN U": v.rtrmrkt_returned,
          // "Rent the Runway Marketplace NET U": v.rtrmrkt_net,
          // "Rent the Runway Marketplace RET %": v.rtrmrkt_ret_rate,
          "Total SHP U": v.total_shipped,
          "Total RTRN U": v.total_returned,
          "Total NET U": v.total_net,
          "Total RET %": v.total_ret_rate,
        };
      })
    );
  }

  const handlePrint = () => {
    window.print();
  };

  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
      width: "20px",
      fixed: 'left',
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.sku.localeCompare(b.sku)
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.inseam - b.inseam
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.style_name - b.style_name
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.wash_name - b.wash_name
      },
    },
    {
      title: "Current Season",
      dataIndex: "new_season",
      key: "new_season",
      className: " b_left b_bottom",
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.new_season - b.new_season
      },
    },
    {
      title: "Bloomingdales-Dropship",
      children: [
        {
          title: "SHP U",
          dataIndex: "blooming_shipped",
          key: "blooming_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.blooming_shipped - b.blooming_shipped;
          },
        },
        {
          title: "RTRN U",
          dataIndex: "blooming_returned",
          key: "blooming_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.blooming_returned - b.blooming_returned;
          },
        },
        {
          title: "NET U",
          dataIndex: "blooming_net",
          key: "blooming_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.blooming_net - b.blooming_net;
          },
        },
        {
          title: "RET %",
          dataIndex: "blooming_ret_rate",
          key: "blooming_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.blooming_ret_rate - b.blooming_ret_rate;
          },
        },
      ]
    },
    {
      title: "Moda Operandi, Inc.",
      children: [
        {
          title: "SHP U",
          dataIndex: "moda_shipped",
          key: "moda_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.moda_shipped - b.moda_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "moda_returned",
          key: "moda_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.moda_returned - b.moda_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "moda_net",
          key: "moda_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.moda_net - b.moda_net
          },
        },
        {
          title: "RET %",
          dataIndex: "moda_ret_rate",
          key: "moda_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.moda_ret_rate - b.moda_ret_rate
          },
        },
      ]
    },
    // {
    //   title: "Maisonette, Inc.",
    //   children: [
    //     {
    //       title: "SHP U",
    //       dataIndex: "maisonet_shipped",
    //       key: "maisonet_shipped",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.maisonet_shipped - b.maisonet_shipped
    //       },
    //     },
    //     {
    //       title: "RTRN U",
    //       dataIndex: "maisonet_returned",
    //       key: "maisonet_returned",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.maisonet_returned - b.maisonet_returned
    //       },
    //     },
    //     {
    //       title: "NET U",
    //       dataIndex: "maisonet_net",
    //       key: "maisonet_net",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.maisonet_net - b.maisonet_net
    //       },
    //     },
    //     {
    //       title: "RET %",
    //       dataIndex: "maisonet_ret_rate",
    //       key: "maisonet_ret_rate",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}%
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.maisonet_ret_rate - b.maisonet_ret_rate
    //       },
    //     },
    //   ]
    // },
    {
      title: "Nordstrom D2C",
      children: [
        {
          title: "SHP U",
          dataIndex: "nord_shipped",
          key: "nord_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_shipped - b.nord_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "nord_returned",
          key: "nord_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_returned - b.nord_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "nord_net",
          key: "nord_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_net - b.nord_net
          },
        },
        {
          title: "RET %",
          dataIndex: "nord_ret_rate",
          key: "nord_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_ret_rate - b.nord_ret_rate
          },
        },
      ]
    },
    {
      title: "Nordstrom Marketplace",
      children: [
        {
          title: "SHP U",
          dataIndex: "nordmrkt_shipped",
          key: "nordmrkt_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nordmrkt_shipped - b.nordmrkt_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "nordmrkt_returned",
          key: "nordmrkt_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nordmrkt_returned - b.nordmrkt_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "nordmrkt_net",
          key: "nordmrkt_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nordmrkt_net - b.nordmrkt_net
          },
        },
        {
          title: "RET %",
          dataIndex: "nordmrkt_ret_rate",
          key: "nordmrkt_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.nordmrkt_ret_rate - b.nordmrkt_ret_rate
          },
        },
      ]
    },
    {
      title: "Saks Fifth Avenue Dropship",
      children: [
        {
          title: "SHP U",
          dataIndex: "saksdrp_shipped",
          key: "saksdrp_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.saksdrp_shipped - b.saksdrp_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "saksdrp_returned",
          key: "saksdrp_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.saksdrp_returned - b.saksdrp_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "saksdrp_net",
          key: "saksdrp_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.saksdrp_net - b.saksdrp_net
          },
        },
        {
          title: "RET %",
          dataIndex: "saksdrp_ret_rate",
          key: "saksdrp_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.saksdrp_ret_rate - b.saksdrp_ret_rate
          },
        },
      ]
    },
    // {
    //   title: "Saks Fifth Avenue Marketplace",
    //   children: [
    //     {
    //       title: "SHP U",
    //       dataIndex: "saksmrkt_shipped",
    //       key: "saksmrkt_shipped",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.saksmrkt_shipped - b.saksmrkt_shipped
    //       },
    //     },
    //     {
    //       title: "RTRN U",
    //       dataIndex: "saksmrkt_returned",
    //       key: "saksmrkt_returned",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.saksmrkt_returned - b.saksmrkt_returned
    //       },
    //     },
    //     {
    //       title: "NET U",
    //       dataIndex: "saksmrkt_net",
    //       key: "saksmrkt_net",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.saksmrkt_net - b.saksmrkt_net
    //       },
    //     },
    //     {
    //       title: "RET %",
    //       dataIndex: "saksmrkt_ret_rate",
    //       key: "saksmrkt_ret_rate",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}%
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.saksmrkt_ret_rate - b.saksmrkt_ret_rate
    //       },
    //     },
    //   ]
    // },
    {
      title: "Anthropologie Dropship",
      children: [
        {
          title: "SHP U",
          dataIndex: "outfitters_shipped",
          key: "outfitters_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.outfitters_shipped - b.outfitters_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "outfitters_returned",
          key: "outfitters_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.outfitters_returned - b.outfitters_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "outfitters_net",
          key: "outfitters_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.outfitters_net - b.outfitters_net
          },
        },
        {
          title: "RET %",
          dataIndex: "outfitters_ret_rate",
          key: "outfitters_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.outfitters_ret_rate - b.outfitters_ret_rate
          },
        },
      ]
    },
    // {
    //   title: "Army & Air Force Exchange Service",
    //   children: [
    //     {
    //       title: "SHP U",
    //       dataIndex: "aafes_shipped",
    //       key: "aafes_shipped",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.aafes_shipped - b.aafes_shipped
    //       },
    //     },
    //     {
    //       title: "RTRN U",
    //       dataIndex: "aafes_returned",
    //       key: "aafes_returned",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.aafes_returned - b.aafes_returned
    //       },
    //     },
    //     {
    //       title: "NET U",
    //       dataIndex: "aafes_net",
    //       key: "aafes_net",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.aafes_net - b.aafes_net
    //       },
    //     },
    //     {
    //       title: "RET %",
    //       dataIndex: "aafes_ret_rate",
    //       key: "aafes_ret_rate",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}%
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.aafes_ret_rate - b.aafes_ret_rate
    //       },
    //     },
    //   ]
    // },
    // {
    //   title: "Rent the Runway Marketplace",
    //   children: [
    //     {
    //       title: "SHP U",
    //       dataIndex: "rtrmrkt_shipped",
    //       key: "rtrmrkt_shipped",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.rtrmrkt_shipped - b.rtrmrkt_shipped
    //       },
    //     },
    //     {
    //       title: "RTRN U",
    //       dataIndex: "rtrmrkt_returned",
    //       key: "rtrmrkt_returned",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.rtrmrkt_returned - b.rtrmrkt_returned
    //       },
    //     },
    //     {
    //       title: "NET U",
    //       dataIndex: "rtrmrkt_net",
    //       key: "rtrmrkt_net",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.rtrmrkt_net - b.rtrmrkt_net
    //       },
    //     },
    //     {
    //       title: "RET %",
    //       dataIndex: "rtrmrkt_ret_rate",
    //       key: "rtrmrkt_ret_rate",
    //       className: " b_left b_bottom",
    //       align: "right",
    //       render: (text, record) => {
    //         return (
    //           <>
    //             {text}%
    //           </>
    //         );
    //       },
    //       sorter: (a, b) => {
    //         return a.rtrmrkt_ret_rate - b.rtrmrkt_ret_rate
    //       },
    //     },
    //   ]
    // },
    {
      title: "Total",
      children: [
        {
          title: "SHP U",
          dataIndex: "total_shipped",
          key: "total_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_shipped - b.total_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "total_returned",
          key: "total_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_returned - b.total_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "total_net",
          key: "total_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_net - b.total_net
          },
        },
        {
          title: "RET %",
          dataIndex: "total_ret_rate",
          key: "total_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return {
              props: {
                style: {
                  color: text >= 30 ? 'red' : 'inherit' // Set color conditionally
                }
              },
              children: `${(text)}%`
            };
          },
          sorter: (a, b) => {
            return a.total_ret_rate - b.total_ret_rate
          },
        },
      ]
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {dropshipTotal?.payload?.data ? (
                          <CSVLink
                            filename={"Dropship-Total.csv"}
                            data={excelData}
                            onClick={() => { }}
                          >
                            <input
                              type="image"
                              name="ImgExcel"
                              alt="Export to excel"
                              id="ImgExcel"
                              title="Export to excel"
                              src={xlsx}
                              style={{ borderWidth: "0px", height: "14px" }}
                            />
                          </CSVLink>
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Dropship Total
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className="col-12">
                        <hr className="my-1" />
                        <div className="row">
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width30">
                                From:
                              </label>
                              <div style={{ marginBottom: "-2px" }} className=" w-100">
                                <Form.Item
                                  className="formFullWidth"
                                  name="from_date"
                                  initialValue={moment().startOf("year")}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width30">
                                To:
                              </label>
                              <div style={{ marginBottom: "-2px" }} className=" w-100">
                                <Form.Item
                                  className="formFullWidth"
                                  name="to_date"
                                  initialValue={moment().add(2, 'year').endOf('year')}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">Gender:</label>
                              <div className=" w-100">
                                <Form.Item name="gender_id" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {gender &&
                                      gender?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.gender_id}>
                                            {it.gender_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} d-flex flex-row align-items-baseline >
                                <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                                  Search
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{
          // overflowY: "scroll",
          // height: "45vh",
        }}
        ref={tableRef} >
        <div >
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : dropshipTotal?.payload?.data.length ? (

            <Table
              style={{ fontSize: '10.3px' }}
              className="test04 mt-3 sales_target_report_table sales_report_res_table_intransit ledger_print speciality_customer_size sales_report_res_table dropship-table-height"
              size="small"
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000]
              }}
              summary={pageData => {
                const allData = Array.isArray(dropshipTotal?.payload?.data)
                  ? dropshipTotal.payload.data
                  : [];

                const safeNumber = val => {
                  const num = parseFloat(val);
                  return isNaN(num) ? 0 : num;
                };

                const sum = (key) =>
                  allData.reduce((acc, obj) => acc + safeNumber(obj?.[key]), 0);

                let blmngShip = sum("blooming_shipped");
                let blmngReturn = sum("blooming_returned");
                let blmngNet = sum("blooming_net");

                let modaShip = sum("moda_shipped");
                let modaReturn = sum("moda_returned");
                let modaNet = sum("moda_net");

                let moisonetShip = sum("maisonet_shipped");
                let moisonetReturn = sum("maisonet_returned");
                let moisonetNet = sum("maisonet_net");

                let nordShip = sum("nord_shipped");
                let nordReturn = sum("nord_returned");
                let nordNet = sum("nord_net");

                let nordmrktShip = sum("nordmrkt_shipped");
                let nordmrktReturn = sum("nordmrkt_returned");
                let nordmrktNet = sum("nordmrkt_net");

                let saksdrpShip = sum("saksdrp_shipped");
                let saksdrpReturn = sum("saksdrp_returned");
                let saksdrpNet = sum("saksdrp_net");

                let saksmrktShip = sum("saksmrkt_shipped");
                let saksmrktReturn = sum("saksmrkt_returned");
                let saksmrktNet = sum("saksmrkt_net");

                let outfittersShip = sum("outfitters_shipped");
                let outfittersReturn = sum("outfitters_returned");
                let outfittersNet = sum("outfitters_net");

                let aafesShip = sum("aafes_shipped");
                let aafesReturn = sum("aafes_returned");
                let aafesNet = sum("aafes_net");

                let rtrmrktShip = sum("rtrmrkt_shipped");
                let rtrmrktReturn = sum("rtrmrkt_returned");
                let rtrmrktNet = sum("rtrmrkt_net");

                let totalShip = sum("total_shipped");
                let totalReturn = sum("total_returned");
                let totalNet = sum("total_net");
                return (
                  <>
                    <Table.Summary.Row >
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right" }}>Total</p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(blmngShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(blmngReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(blmngNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(modaShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(modaReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(modaNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      {/* <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(moisonetShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(moisonetReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(moisonetNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell> */}
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordmrktShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordmrktReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordmrktNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(saksdrpShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(saksdrpReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(saksdrpNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      {/* <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(saksmrktShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(saksmrktReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(saksmrktNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell> */}
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(outfittersShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(outfittersReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(outfittersNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      {/* <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(aafesShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(aafesReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(aafesNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell> */}
                      {/* <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(rtrmrktShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(rtrmrktReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(rtrmrktNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell> */}
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(totalShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(totalReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(totalNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
              bordered
              columns={columns}
              scroll={{ x: "max-content" }}
              dataSource={dropshipTotal?.payload?.data}
            />
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DropshipTotal;

